import { decodeFCompositionId, FCompositionTypesEnum } from '@spazious/dollhouse-shallow-graph';

import { FArrangement, FArrangementFactory } from '../../farrangements/index.js';
import { FEnsemble, FEnsembleFactory } from '../../fensembles/index.js';
import { createHookInstance } from '../../utils/index.js';

/**
 * This hook is used to create an instance of FComposition and load furniture models.
 *
 */
export const useFCompositionInstance = createHookInstance<FEnsemble | FArrangement>(
  (id, schema) => {
    const { type, subtype } = decodeFCompositionId(id);

    switch (type) {
      case FCompositionTypesEnum.FEnsemble:
        return FEnsembleFactory(subtype, schema) as any;
      case FCompositionTypesEnum.FArrangement:
        return FArrangementFactory(subtype, schema) as any;
      default:
        throw new Error(`Unknown FComposition type: ${type}`);
    }
  }
);
